<template>
  <div class="popup-layer">
    <!-- Renders all the current opened popups and alerts -->

    <template v-for="(popup, index) in popups">

      <!-- in case this is a popup, we render a popup -->
      <component v-if="popup.popup"
                 :is="popup.popup"
                 :style="getPopupStyle(zIndex + index, index)"
                 :ref="`popup_${index}`"
                 :data="popup.data"
                 @event="popup.handler"/>

      <!-- else, we render an alert -->
      <alert v-else
             :width="popup.alert.width"
             :height="popup.alert.height"
             :centeredX="popup.alert.centeredX"
             :centeredY="popup.alert.centeredY"
             :marginLeft="popup.alert.marginLeft"
             :marginTop="popup.alert.marginTop"
             :closeButton="popup.alert.closeButton"
             :closeButtonType="popup.alert.closeButtonType"
             :content="popup.alert.content"
             :type="popup.alert.type"
             :buttons="popup.alert.buttons"
             :animate="popup.alert.animate"
             :header="popup.alert.header"
             :closeOnBlur="popup.alert.closeOnBlur"
             :closeOnEsc="popup.alert.closeOnEsc"
             @buttonClick="onAlertButtonClick(popup.alert, $event)"
             :style="getPopupStyle(zIndex + index, index)"
             :ref="`popup_${index}`"/>

    </template>

    <!-- Renders the loader -->
    <loader v-if="loaderVisible" :style="{'z-index': zIndex + popups.length}"/>

    <!-- Renders the overlay only if there is at least one rendered popup -->
    <div v-if="popups.length > 0 || loaderVisible"
         class="overlay"
         :style="{'z-index': getOverLayZIndex}"
         @click="onOverlayClick"></div>

  </div>
</template>

<script>

  import { mapGetters, mapMutations } from 'vuex';

  import Alert from './AlertPopup.vue';
  import Loader from '../Loader/Loader.vue';

  export default {

    components: {
      alert: Alert,
      loader: Loader
    },

    created() {
      this.zIndex = 10000;
    },

    computed: {

      ...mapGetters([
        'popups',
        'alerts',
        'loaderVisible'
      ]),

      getOverLayZIndex() {
        if (!this.loaderVisible)
          return this.zIndex + this.popups.length - 2;
        return this.zIndex + this.popups.length - 1;
      }

    },

    methods: {

      ...mapMutations([
        'closePopup'
      ]),

      onOverlayClick() {

        if (this.popups.length == 0 || this.loaderVisible)
          return;

        let closeOnBlur = this.$refs[`popup_${this.popups.length - 1}`][0].$children[0].closeOnBlur;
        if (closeOnBlur)
          this.closePopup();

      },

      getPopupStyle(zIndex, index) {
        let css = {
          'z-index': zIndex
        };

        // in case this is not the last popup, we show a border
        if (index < this.popups.length - 1 || this.loaderVisible)
          css.border = '1px solid #dadada';
        return css;
      },

      onAlertButtonClick(alert, alertResultType) {
        if (alert.buttonClick)
          alert.buttonClick(alertResultType);
      }

    }

  }

</script>

<style lang="scss" scoped>

  .popup-layer {

    .overlay {
      position: fixed; /* Sit on top of the page content */
      width: 100%; /* Full width (cover the whole page) */
      height: 100%; /* Full height (cover the whole page) */
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0,0,0,0.4); /* Black background with opacity */
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/Common/Popup/PopupLayer.vue